import { render, staticRenderFns } from "./AIVoiceMonitor.vue?vue&type=template&id=ce88827a&scoped=true"
import script from "./AIVoiceMonitor.vue?vue&type=script&lang=js"
export * from "./AIVoiceMonitor.vue?vue&type=script&lang=js"
import style0 from "./AIVoiceMonitor.vue?vue&type=style&index=0&id=ce88827a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce88827a",
  null
  
)

export default component.exports